import { useEffect, useState } from 'react';
import useResponsive from '../common/useResponsive';
import { atom, useAtom } from 'jotai';
import useSearchStore from '@/studbook/store/useSearchStore';

export type TDisplayType = 'list' | 'gallery' | 'map';
const displayTypeAtom = atom<TDisplayType>('list');
export default function useAnimalDisplayType() {
  const { isMobile } = useResponsive();
  const [resultDisplay, setResultDisplay] = useAtom(displayTypeAtom);
  const searchType = useSearchStore((s) => s.searchType);
  const changeResultDisplay = (display: TDisplayType) => {
    setResultDisplay(display);
    sessionStorage.setItem('resultDisplay', display);
  };

  useEffect(() => {
    const lastSavedResultDisplay = sessionStorage.getItem(
      'resultDisplay',
    ) as TDisplayType | null;
    const savedResultDisplay =
      lastSavedResultDisplay ?? (isMobile ? 'gallery' : 'list');
    setResultDisplay(savedResultDisplay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (resultDisplay !== 'list' && searchType === 'member') {
      setResultDisplay('list');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchType]);
  return {
    isMobile,
    resultDisplay,
    setResultDisplay: changeResultDisplay,
  };
}
